export { default } from './UnscoredTableItemTitleSection'
